import { formatAxiosErrorMessage } from "../api/httpError";
import { clearAuthSession } from "./authSession";
import {
  applyAuthorizationHeader,
  buildAuthorizationHeader,
  isLikelyJwt,
  readStoredAccessToken,
  stripBearerPrefix,
} from "./authToken";
import Constant from "../util/constant";
import { store } from "../store";
import instance from "../hooks/axios";

instance.interceptors.request.use(
  (config) => {
    if (config?.skipAuthToken) return config;
    const accessToken = readStoredAccessToken();
    const authorization = buildAuthorizationHeader(accessToken);
    if (authorization) {
      applyAuthorizationHeader(config, authorization);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => response?.data,
  async (error) => {
    const prevRequest = error?.config;
    if (prevRequest?.url === "refresh" && error?.response?.status === 401) {
      await clearAuthSession(store.dispatch);
      window.location.href = "/";
      return;
    }
    if (error?.response?.status === 401 && !prevRequest?.sent) {
      prevRequest.sent = true;
      try {
        const response = await instance.post("refresh", {
          refreshtoken: window.localStorage.getItem(
            Constant.LOCALSTORAGEKEYS.REFRESHTOKEN
          ),
        });
        const next = stripBearerPrefix(
          response?.accessToken ?? response?.data?.accessToken ?? ""
        );
        const nextRefresh = stripBearerPrefix(
          response?.refreshToken ?? response?.data?.refreshToken ?? ""
        );
        if (!isLikelyJwt(next)) {
          throw new Error("Refresh returned no valid access token");
        }
        const authorization = buildAuthorizationHeader(next);
        applyAuthorizationHeader(prevRequest, authorization);
        window.localStorage.setItem(Constant.LOCALSTORAGEKEYS.ACCESSTOKEN, next);
        if (nextRefresh) {
          window.localStorage.setItem(
            Constant.LOCALSTORAGEKEYS.REFRESHTOKEN,
            nextRefresh
          );
        }
        return instance(prevRequest);
      } catch (refreshErr) {
        console.log("refresh-token error", refreshErr);
      }
    }
    if (error?.response?.status === 422 && error.response?.data) {
      console.error("API 422:", error.response.data);
    }
    return Promise.reject(formatAxiosErrorMessage(error));
  }
);

export default instance;
